// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__fD0bq","icon":"footer_icon__YqZo6","noSelect":"footer_noSelect__luRCu","footerIcons":"footer_footerIcons__cgYbI"};